export const NewEmployeeCandidate = () => {
  return (
    <>
      TBA: New Employee Candidate form page. In Legacy UI, when Manager cannot
      create an employee themselves, there is a form to propose a candidate.
    </>
  );
};
